// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cash-flow-report-mapping-card[data-v-43847773] {\n  margin-bottom: 16px;\n}\n.cash-flow-report-mapping-card__icon[data-v-43847773] {\n  color: white;\n  font-size: 18px;\n}\n.cash-flow-report-mapping-card__add-row-container[data-v-43847773] {\n  margin-top: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
